import styled from "styled-components";
import { keyframes } from "styled-components";


export const ContainerFather = styled.div`
width: 100%;
display: flex;
justify-content: center;

`

export const Container = styled.div`
  padding: 1.5rem;
  display: flex;
  justify-content: center;
  position: relative;
  width: 70%;
  margin: auto;
`;
//  card
export const Card = styled.div`
  width: 100%;
  //min-width: 250px;
  //max-width: 280px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;

      @media screen and (min-width: 600px) {
   
       //max-width: 600px;
    
    
  }
  
`;

export const Header = styled.div`
  background: #4e535aff;
  color: white;
  padding: 0.75rem 1rem;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
`;

export const Messages = styled.div`
  height: 350px;
  overflow-y: auto;
  padding: 1rem;
  background: #f8f9fa;
`;

export const MessageRow = styled.div`
  display: flex;
  justify-content: ${({ isMine }) => (isMine ? "flex-end" : "flex-start")};
  margin-bottom: 1rem;
`;

export const MessageBubble = styled.div`
 // max-width: 70%;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  background: ${({ isMine }) => (isMine ? "#749b82ff" : "#ebf0f5ff")};
  color: ${({ isMine }) => (isMine ? "#e1eaf1ff" : "#8d9bacff")};

   word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
`;

export const Author = styled.small`
  display: block;
  color: ${({ isMine }) => (isMine ? "#dbeafe" : "#6c757d")};
  margin-bottom: 0.25rem;
`;

export const Time = styled.small`
  display: block;
  text-align: right;
  color: #52575bff;
  margin-top: 0.25rem;
`;

export const Footer = styled.div`
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  position: relative;
`;

export const InputGroup = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const Input = styled.input`
  
  border-radius: 4px;
  border: 1px solid #ced4da;
  outline: none;

  &:focus {
    border-color: #747a82ff;
  }
`;
  
export const SendButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: none;
  background: #2b2d2fff;
  color: white;
  cursor: pointer;

  &:hover {
    background: #0b5ed7;
  }
`;

export const UsersContainer = styled.div`
   display: flex;    
   flex-wrap: wrap;
`
export const ItemUser = styled.a`

  background-color: aliceblue;
  margin: 10px;
  padding: 5px;
  border-radius: 3px;

  :active {
    background-color: rgba(202, 140, 140, 0.9);
  }


`

const blink = keyframes`
  0%   { opacity: 0.2; }
  20%  { opacity: 1; }
  100% { opacity: 0.2; }
`;  

export const Typing = styled.div`
  font-size: 14px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 4px;
  position: ${(props)=> props.positionn};
  top: ${(props) => props.topp};
  right: ${({rightt}) => rightt};
  bottom: ${({bottomm}) => bottomm};
  left: ${({leftt}) => leftt};
  margin-bottom: ${({mb}) => mb};
`;

export const Dots = styled.span`
  display: flex;

  span {
    font-size: 20px;
    line-height: 1;
    animation: ${blink} 2s infinite both;
  }

  span:nth-child(2) {
    animation-delay: 0.2s;
  }

  span:nth-child(3) {
    animation-delay: 0.4s;
    
  }
`;



